import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Checkbox, Button } from 'antd';

export const QuestionnaireDependedAnswers = ({
  onAddAnswers,
  dataSortedSections,
  loadingSections,
  dependentAnswers,
  setDependentAnswers
}) => {
  const { t } = useTranslation();

  const onChange = (e, answer) => {
    let newAnsws;

    if (e.target.checked) {
      newAnsws = [...dependentAnswers, answer];
    } else {
      newAnsws = dependentAnswers.filter((a) => a.id !== answer.id);
    }

    setDependentAnswers(newAnsws);
  };

  const onAdd = () => {
    onAddAnswers(dependentAnswers);
  };

  if (loadingSections) return <div>{t('Loading')}...</div>;

  return (
    <div>
      <Box>
        {dataSortedSections &&
          dataSortedSections.length &&
          dataSortedSections.map((section) => (
            <Fragment key={section.id}>
              {section && (
                <SectionBox>
                  <div>{section.section} (section)</div>
                  {section.questionGroups &&
                    section.questionGroups.length &&
                    section.questionGroups.map((group) => (
                      <Fragment key={group.id}>
                        {group && (
                          <GroupBox>
                            <div>{group.title} (group)</div>
                            {group.questions &&
                              group.questions.length &&
                              group.questions.map((question) => (
                                <Fragment key={question.id}>
                                  {question && (
                                    <QuestionBox>
                                      <div>{question.question} (question)</div>
                                      {question.availableAnswers &&
                                        question.availableAnswers.length &&
                                        question.availableAnswers.map((answer) => (
                                          <Fragment key={answer.id}>
                                            {answer && (
                                              <AnswerBox>
                                                <Checkbox
                                                  onChange={(e) => onChange(e, answer)}
                                                  checked={dependentAnswers.includes(answer)}
                                                >
                                                  {answer.answer}
                                                </Checkbox>
                                              </AnswerBox>
                                            )}
                                          </Fragment>
                                        ))}
                                    </QuestionBox>
                                  )}
                                </Fragment>
                              ))}
                          </GroupBox>
                        )}
                      </Fragment>
                    ))}
                </SectionBox>
              )}
            </Fragment>
          ))}
      </Box>
      <BtnBox>
        <Button onClick={onAdd} type='primary' style={{ marginTop: '30px' }}>
          {t('Add answers')}
        </Button>
      </BtnBox>
    </div>
  );
};

const Box = styled.div`
  height: 600px;
  overflow-y: scroll;
`;

const AnswerBox = styled.div`
  padding-left: 15px;
`;

const QuestionBox = styled.div`
  margin-bottom: 10px;
  padding-left: 15px;
`;

const GroupBox = styled.div`
  margin-bottom: 10px;
  padding-left: 15px;
`;

const SectionBox = styled.div`
  margin-bottom: 10px;
`;

const BtnBox = styled.div`
  text-align: right;
`;
